/**
 * Format helpers for currency, percentages, and dates.
 */

const BRL = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
});

const USD = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

export function fmtMoney(value, currency = "BRL") {
  if (value == null || isNaN(value)) return "—";
  if (currency === "BRL") return BRL.format(value);
  if (currency === "USD") return USD.format(value);
  return `${value.toFixed(2)} ${currency}`;
}

export function fmtPct(value, digits = 2) {
  if (value == null || isNaN(value)) return "—";
  const sign = value > 0 ? "+" : "";
  return `${sign}${Number(value).toFixed(digits)}%`;
}

export function fmtScore(value) {
  if (value == null || isNaN(value)) return "0.0";
  const sign = value > 0 ? "+" : "";
  return `${sign}${Number(value).toFixed(1)}`;
}

export function fmtVolume(value) {
  if (value == null || isNaN(value)) return "—";
  const v = Number(value);
  if (v >= 1e9) return `${(v / 1e9).toFixed(2)}B`;
  if (v >= 1e6) return `${(v / 1e6).toFixed(2)}M`;
  if (v >= 1e3) return `${(v / 1e3).toFixed(1)}K`;
  return v.toFixed(0);
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    // Detect "YYYY-MM-DD" (calendar date without time) — render literally to avoid
    // UTC→local timezone shifts that move the day back by one in BRT.
    if (typeof iso === "string" && /^\d{4}-\d{2}-\d{2}$/.test(iso)) {
      const [y, m, d] = iso.split("-");
      return `${d}/${m}/${y}`;
    }
    const d = new Date(iso);
    return d.toLocaleDateString("pt-BR");
  } catch {
    return iso;
  }
}

export function recommendationColor(label) {
  switch (label) {
    case "Compra forte":
      return "bg-buy-soft text-buy-strong border-buy";
    case "Compra":
      return "bg-buy-soft text-buy border-buy";
    case "Venda":
      return "bg-sell-soft text-sell border-sell";
    case "Venda forte":
      return "bg-sell-soft text-sell-strong border-sell";
    default:
      return "bg-muted text-muted-foreground border-border";
  }
}
